export default "__VITE_ASSET__DpE13hoZ__"